export const useStoreSignup = defineStore('StoreSignup', {
    state: () => ({
        signup: null,
        disabled: null,
        success: null,
        error: null,
    }),
    actions: {
        initSignup() {
            this.signup = {
                first_name: null,
                last_name: null,
                email: null,
                message: null,
                recaptcha_response: null,
                notifications_mailers: null,
                notifications_mailers_consent_method: null,
                notifications_mailers_title: null,
                notifications_mailers_text: null,
                notifications_mailers_info: null,
            };
        },
        updateSignupField({field, value}) {
            if (this.signup[field] === undefined)
                throw new Error('Attempted to update a signup field which does not exist (' + field + ').');
            this.signup[field] = value;
        },
        async postSignup() {
            this.success = null;
            this.error = null;
            this.disabled = true;
            const {user, error} = await useEntityMe().post(this.signup);
            this.error = error;
            this.disabled = false;
            if (user) {
                this.initSignup();
                await useStoreAuth().setCurrentUser(user.jwt);
                await useStoreStreams().getStreams();
                useStoreHelpdesk().initHelpdesk();
                const {$returnRoute} = useNuxtApp();
                $returnRoute.use();
            }
        },
        clearError() {
            this.error = null;
        },
        clearSuccess() {
            this.success = null;
        },
    },
});
